import { render, staticRenderFns } from "./CreditReportItemEdit.vue?vue&type=template&id=5110e67b&"
import script from "./CreditReportItemEdit.vue?vue&type=script&lang=js&"
export * from "./CreditReportItemEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports